import api from "../api";

const Actions = {};

Actions.fetchUnits = () => {
  return (dispatch, getState) => {
    dispatch({ type: "FETCH_UNITS_REQUEST" });
    const params = getState().units.fetchParams;
    api
      .fetch("/units", params)
      .then(response => {
        // console.log(response)
        dispatch({ type: "FETCH_UNITS", response });
      })
      .catch(response => {
        console.log(response.error);
        dispatch({ type: "FETCH_UNITS_FAILURE", response });
      });
  };
};

Actions.fetchUnit = unitID => {
  return dispatch => {
    dispatch({ type: "FETCH_UNIT_REQUEST" });
    api
      .fetch(`/units/${unitID}`)
      .then(response => {
        dispatch({ type: "FETCH_UNIT", response });
      })
      .catch(response => {
        dispatch({ type: "FETCH_UNIT_FAILURE", response });
      });
  };
};

Actions.onUpdate = () => {
  return (dispatch, getState) => {
    dispatch({ type: "PATCH_UNIT_REQUEST" });
    const unit = getState().units.unit;
    const data = {
      unit: {
        code: unit.code,
        name: unit.name
      }
    };
    return api
      .patch(`/units/${unit.id}`, data)
      .then(response => {
        dispatch({ type: "PATCH_UNIT", response });
        api.openNotification(
          "success",
          "Единица измерения",
          "Успешно обновлена!"
        );
      })
      .catch(response => {
        if (response.errors) {
          response.errors.map(error => {
            api.openNotification("error", "Единица измерения", error);
          });
        }
        dispatch({ type: "PATCH_UNIT_FAILURE", response });
      });
  };
};

Actions.onNew = () => {
  return dispatch => {
    dispatch({
      type: "UNIT_NEW"
    });
  };
};

Actions.onCreate = () => {
  return (dispatch, getState) => {
    dispatch({ type: "POST_UNIT_REQUEST" });
    const unit = getState().units.unit;
    const data = {
      unit: {
        code: unit.code,
        name: unit.name
      }
    };
    return api
      .post(`/units`, data)
      .then(response => {
        dispatch({ type: "POST_UNIT", response });
        api.openNotification(
          "success",
          "Единица измерения",
          "Успешно создана!"
        );
      })
      .catch(response => {
        if (response.errors) {
          response.errors.map(error => {
            api.openNotification("error", "Единица измерения", error);
          });
        }
        dispatch({ type: "POST_UNIT_FAILURE", response });
      });
  };
};

Actions.onDelete = id => {
  return dispatch => {
    dispatch({ type: "DELETE_UNIT_REQUEST" });
    return api
      .delete(`/units/${id}`)
      .then(response => {
        api.openNotification("success", "Единица измерения", "Успешно удалена!");
        dispatch({ type: "DELETE_UNIT", response });
      })
      .catch(response => {
        if (response.errors) {
          response.errors.map(error => {
            api.openNotification("error", "Единица измерения", error);
          });
        }
        dispatch({
          type: "DELETE_UNIT_FAILURE"
        });
      });
  };
};

Actions.onSearch = value => {
  return dispatch => {
    dispatch({
      type: "REQUEST_UNIT_SEARCH",
      value: value
    });
    return Promise.resolve();
  };
};

Actions.onChangePage = value => {
  return dispatch => {
    dispatch({
      type: "REQUEST_UNIT_CHANGE_PAGE",
      value: value
    });
    return Promise.resolve();
  };
};

Actions.onChangeLimit = value => {
  return dispatch => {
    dispatch({
      type: "REQUEST_UNIT_CHANGE_LIMIT",
      value: value
    });
    return Promise.resolve();
  };
};

Actions.onChangeCode = value => {
  return dispatch => {
    dispatch({
      type: "UNIT_CHANGE_CODE",
      value: value
    });
  };
};

Actions.onChangeName = value => {
  return dispatch => {
    dispatch({
      type: "UNIT_CHANGE_NAME",
      value: value
    });
  };
};

export default Actions;
